module.exports = __webpack_public_path__ + "images/q1-otro-color-img.jpg";